(() => {
  if (customElements.get('meubelista-predictive-search')) return;

  let nextId = 0;
  const cache = new Map();

  customElements.define(
    'meubelista-predictive-search',
    class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;

        this.header = this.closest('meubelista-header');

        this.form = this.header?.querySelector(
          '.mbh-main form.mbh-search'
        );

        this.input = this.form?.querySelector(
          'input[type="search"]'
        );

        this.dialog = this.header?.querySelector('.mbh-dialog');

        if (!this.input || !this.dialog) return;

        this.events = new AbortController();

        const opts = {
          signal: this.events.signal
        };

        this.sequence = 0;
        this.open = false;
        this.frame = 0;
        this.pointerId = null;

        this.panel = document.createElement('div');
        this.panel.id = 'mps-popup-' + (++nextId);
        this.panel.className = 'mps-panel';
        this.panel.hidden = true;
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-label', 'Zoekresultaten');

        this.panel.innerHTML = `
          <div class="mps-top">
            <button
              type="button"
              class="mps-close"
              aria-label="Zoekresultaten sluiten"
            >
              Sluiten
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div class="mps-content"></div>

          <div class="mps-footer">
            <a class="mps-all" data-mps-option>
              Alle resultaten
            </a>
          </div>
        `;

        this.form.after(this.panel);

        this.body = this.panel.querySelector('.mps-content');
        this.all = this.panel.querySelector('.mps-all');

        this.status = document.createElement('span');
        this.status.className = 'mps-sr';
        this.status.setAttribute('role', 'status');
        this.status.setAttribute('aria-live', 'polite');
        this.status.setAttribute('aria-atomic', 'true');

        this.panel.after(this.status);

        this.original = {};

        Object.entries({
          role: 'combobox',
          autocomplete: 'off',
          'aria-autocomplete': 'list',
          'aria-haspopup': 'dialog',
          'aria-expanded': 'false',
          'aria-controls': this.panel.id
        }).forEach(([key, value]) => {
          this.original[key] = this.input.getAttribute(key);
          this.input.setAttribute(key, value);
        });

        this.input.addEventListener('input', event => {
          if (!event.isComposing) this.queue();
        }, opts);

        this.input.addEventListener('compositionstart', () => {
          this.dismiss();
        }, opts);

        this.input.addEventListener('compositionend', () => {
          this.queue();
        }, opts);

        this.input.addEventListener('focus', () => {
          if (
            !this.suppressFocus &&
            this.pointerId === null &&
            !this.header.closingMenu
          ) {
            this.queue();
          }
        }, opts);

        this.input.addEventListener('keydown', event => {
          if (!this.open || event.isComposing) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.dismiss(true);
          } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.panel.querySelector('a[href]')?.focus();
          }
        }, opts);

        this.panel.querySelector('.mps-close').addEventListener(
          'click',
          event => {
            event.stopPropagation();
            this.dismiss(true);
          },
          opts
        );

        this.panel.addEventListener('pointerdown', event => {
          if (
            event.button !== 0 ||
            event.isPrimary === false ||
            !event.target.closest?.('a[href]')
          ) {
            return;
          }

          clearTimeout(this.pointerTimer);

          this.pointerId = event.pointerId;
          event.stopPropagation();
        }, {
          ...opts,
          capture: true
        });

        this.panel.addEventListener('click', event => {
          if (!event.target.closest?.('a[href]')) return;

          event.stopPropagation();
          this.finishPointer(0);
        }, {
          ...opts,
          capture: true
        });

        document.addEventListener('pointerup', event => {
          if (event.pointerId === this.pointerId) {
            this.finishPointer(500);
          }
        }, {
          ...opts,
          capture: true
        });

        document.addEventListener('pointercancel', event => {
          if (event.pointerId === this.pointerId) {
            this.finishPointer(0);
          }
        }, {
          ...opts,
          capture: true
        });

        this.panel.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.dismiss(true);
            return;
          }

          if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;

          const links = [
            ...this.panel.querySelectorAll('a[href]')
          ];

          const index = links.indexOf(document.activeElement);

          if (index < 0) return;

          event.preventDefault();

          if (event.key === 'ArrowUp' && index === 0) {
            this.focusInput();
          } else {
            const direction = event.key === 'ArrowDown' ? 1 : -1;

            links[
              (index + direction + links.length) % links.length
            ]?.focus();
          }
        }, opts);

        this.form.addEventListener('submit', event => {
  if (!this.input.value.trim()) {
    event.preventDefault();
    return;
  }

  this.dismiss();
}, opts);

        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) this.dismiss();
        }, opts);

        document.addEventListener('pointerdown', event => {
          if (this.open && !this.inside(event.target)) {
            this.dismiss();
          }
        }, opts);

        document.addEventListener('focusin', event => {
          if (
            !this.open ||
            this.pointerId !== null ||
            this.inside(event.target) ||
            event.target === this.dialog
          ) {
            return;
          }

          this.dismiss();
        }, opts);

        const position = () => {
          if (
            !this.open ||
            this.frame ||
            this.pointerId !== null
          ) {
            return;
          }

          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.position();
          });
        };

        this.observer = new ResizeObserver(position);
        this.observer.observe(this.header);

        window.addEventListener('resize', position, opts);

        window.addEventListener('scroll', position, {
          ...opts,
          passive: true
        });

        window.visualViewport?.addEventListener(
          'resize',
          position,
          opts
        );

        window.visualViewport?.addEventListener(
          'scroll',
          position,
          opts
        );

        window.addEventListener('pageshow', () => {
          this.dismiss();
        }, opts);

        window.addEventListener('blur', () => {
          this.finishPointer(0);
        }, opts);
      }

      inside(target) {
        return (
          this.form.contains(target) ||
          this.panel.contains(target)
        );
      }

      focusInput() {
        this.suppressFocus = true;

        try {
          this.input.focus({ preventScroll: true });
        } finally {
          this.suppressFocus = false;
        }
      }

      finishPointer(delay) {
        clearTimeout(this.pointerTimer);

        if (this.pointerId === null) return;

        this.pointerTimer = setTimeout(() => {
          this.pointerId = null;

          const update = this.pendingUpdate;
          this.pendingUpdate = null;

          if (update) update();

          this.position();
        }, delay);
      }

      queue() {
        if (this.header.closingMenu) return;

        const query = this.input.value.trim();

        if (this.open && query === this.query) return;

        this.dismiss();

        if (query.length < 2) return;

        this.mobileMode = window.innerWidth < 900;

        if (this.mobileMode) {
          if (typeof this.header.openMenu !== 'function') return;

          this.suppressFocus = true;

          try {
            this.header.openMenu(true);
          } finally {
            this.suppressFocus = false;
          }

          this.dialog.append(this.panel);
          this.dialog.classList.add('mps-searching');
        } else {
          this.form.after(this.panel);
        }

        this.open = true;
        this.query = query;

        const job = this.sequence;

        const full = new URL(
          this.form.action,
          location.origin
        );

        new FormData(this.form).forEach((value, key) => {
          full.searchParams.set(key, value);
        });

        full.searchParams.set('q', query);
        this.all.href = full.href;

        this.header.querySelectorAll(
          '.mbh-nav details[open]'
        ).forEach(item => {
          item.open = false;
        });

        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.body.setAttribute('aria-busy', 'true');

        const loading = document.createElement('p');
        loading.className = 'mps-message';
        loading.textContent = 'Even zoeken…';

        this.body.replaceChildren(loading);
        this.status.textContent = 'Zoeken…';

        this.position();

        let url;

        try {
          if (!this.dataset.url) {
            throw new Error('Missing search URL');
          }

          url = new URL(
            this.dataset.url,
            location.origin
          );
        } catch {
          this.showError(job);
          return;
        }

        url.searchParams.set('q', query);

        url.searchParams.set(
          'section_id',
          'meubelista-predictive-results'
        );

        url.searchParams.set(
          'resources[type]',
          'product,collection'
        );

        url.searchParams.set('resources[limit]', '10');

        url.searchParams.set(
          'resources[limit_scope]',
          'each'
        );

        url.searchParams.set(
          'resources[options][unavailable_products]',
          'last'
        );

        const key = url.href;
        const hit = cache.get(key);

        if (hit && Date.now() - hit.time < 60000) {
          try {
            this.render(hit.html, job);
            return;
          } catch {
            cache.delete(key);
          }
        }

        this.timer = setTimeout(() => {
          this.load(key, job);
        }, 250);
      }

      async load(url, job) {
        const request = new AbortController();
        this.request = request;

        const timeout = setTimeout(() => {
          request.abort();
        }, 8000);

        try {
          const response = await fetch(url, {
            signal: request.signal,
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html'
            }
          });

          if (!response.ok) {
            throw new Error('Search unavailable');
          }

          const html = await response.text();

          if (!this.current(job)) return;

          this.render(html, job);

          cache.set(url, {
            html,
            time: Date.now()
          });

          if (cache.size > 20) {
            cache.delete(cache.keys().next().value);
          }
        } catch {
          this.showError(job);
        } finally {
          clearTimeout(timeout);

          if (this.request === request) {
            this.request = null;
          }
        }
      }

      current(job) {
        return (
          this.isConnected &&
          this.open &&
          this.sequence === job &&
          this.input.value.trim() === this.query
        );
      }

      updateWhenReady(update) {
        if (this.pointerId !== null) {
          this.pendingUpdate = update;
        } else {
          update();
        }
      }

      render(html, job) {
        if (!this.current(job)) return;

        const parsed = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const content = parsed.querySelector(
          '[data-mps-results]'
        );

        if (!content) {
          throw new Error('Missing search section');
        }

        this.updateWhenReady(() => {
          if (!this.current(job)) return;

          this.body.replaceChildren(
            document.importNode(content, true)
          );

          this.body.setAttribute('aria-busy', 'false');

          this.status.textContent =
            (Number(content.dataset.products) || 0) +
            ' productsuggesties en ' +
            (Number(content.dataset.collections) || 0) +
            ' categorieën.';

          this.position();
        });
      }

      showError(job) {
        if (!this.current(job)) return;

        this.updateWhenReady(() => {
          if (!this.current(job)) return;

          const message = document.createElement('p');
          message.className = 'mps-message';

          message.textContent =
            'De suggesties zijn tijdelijk niet beschikbaar. ' +
            'Je kunt hieronder alle zoekresultaten bekijken.';

          this.body.replaceChildren(message);
          this.body.setAttribute('aria-busy', 'false');

          this.status.textContent =
            'Suggesties niet beschikbaar. Gebruik Alle resultaten.';
        });
      }

      position() {
        if (!this.open || this.pointerId !== null) return;

        const mobile = window.innerWidth < 900;

        if (
          mobile !== this.mobileMode ||
          !this.input.getClientRects().length
        ) {
          this.dismiss();
          return;
        }

        if (mobile) return;

        const vv = window.visualViewport;

        const width =
          vv?.width ||
          document.documentElement.clientWidth;

        const height =
          vv?.height ||
          window.innerHeight;

        const offsetTop = vv?.offsetTop || 0;

        const top = Math.max(
          offsetTop,
          this.header.getBoundingClientRect().bottom
        );

        Object.assign(this.panel.style, {
          position: 'fixed',
          left: (vv?.offsetLeft || 0) + 'px',
          right: 'auto',
          top: top + 'px',
          bottom: 'auto',
          width: width + 'px',
          height: 'auto',
          maxHeight: Math.max(
            0,
            Math.min(620, offsetTop + height - top - 12)
          ) + 'px'
        });
      }

      dismiss(focus = false) {
        clearTimeout(this.timer);
        clearTimeout(this.pointerTimer);

        this.pointerId = null;
        this.pendingUpdate = null;

        this.request?.abort();
        this.sequence++;
        this.open = false;

        if (!this.panel) return;

        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.body.setAttribute('aria-busy', 'false');
        this.status.textContent = '';

        this.dialog.classList.remove(
          'mps-searching',
          'mps-search-mode'
        );

        if (focus && this.input.isConnected) {
          this.focusInput();
        }
      }

      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();

        this.dismiss();
        cancelAnimationFrame(this.frame);

        this.panel?.remove();
        this.status?.remove();

        Object.entries(this.original || {}).forEach(
          ([key, value]) => {
            if (value === null) {
              this.input.removeAttribute(key);
            } else {
              this.input.setAttribute(key, value);
            }
          }
        );

        this.events = null;
      }
    }
  );
})();